import { principlesList, teamQuotes } from "@/mocks/site";

export default function PrinciplesBand() {
  return (
    <section className="w-full bg-primary-900">
      <div className="w-full px-5 md:px-10 py-14 md:py-20">
        <div className="max-w-3xl">
          <span className="inline-flex items-center gap-1.5 text-xs tracking-[0.22em] text-accent-300 font-medium">
            <span className="w-5 h-px bg-accent-400" />
            编辑原则
          </span>
          <h2 className="mt-3 font-heading text-2xl md:text-3xl font-bold text-background-50 leading-snug">
            事实先摆好，再说结论
          </h2>
          <p className="mt-3 text-sm md:text-base leading-relaxed text-background-100/80">
            我们不追求最快，但尽量做到每个节点都能被核对。以下四条是整理每一起事件时都会遵守的底线。
          </p>
        </div>

        <div className="mt-9 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {principlesList.map((item) => (
            <div
              key={item.title}
              className="rounded-lg border border-background-50/15 bg-background-50/5 p-5 md:p-6"
            >
              <span className="w-10 h-10 flex items-center justify-center rounded-md bg-accent-400/20 text-accent-200 text-lg">
                <i className={item.icon} />
              </span>
              <h3 className="mt-4 font-heading text-sm md:text-base font-bold text-background-50">
                {item.title}
              </h3>
              <p className="mt-2 text-sm leading-relaxed text-background-100/75">{item.desc}</p>
            </div>
          ))}
        </div>

        <div className="mt-12 pt-10 border-t border-background-50/15">
          <h3 className="font-heading text-base font-bold text-background-50">读者怎么说</h3>
          <div className="mt-5 grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-5">
            {teamQuotes.map((quote) => (
              <figure
                key={quote.name}
                className="rounded-lg border border-background-50/15 bg-background-50/5 p-5"
              >
                <i className="ri-double-quotes-l text-accent-300 text-xl" />
                <blockquote className="mt-2 text-sm leading-relaxed text-background-100/85">
                  {quote.text}
                </blockquote>
                <figcaption className="mt-3 text-xs text-background-200/70">
                  {quote.name} · {quote.role}
                </figcaption>
              </figure>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}